<template>
    <div class="flex flex-col tracking-wider w-full max-w-[530px] p-8 border border-gray-100 lg:border-gray-300 rounded-md bg-gray-100 text-gray-700">
        <div class="text-xl pb-6 border-b border-gray-300 w-full flex justify-center text-center">Resend Email Verification</div>
        <div v-if="registrationResponseType" class="pt-6">
            <div v-if="registrationResponseType=='success'" class="flex flex-col justify-center items-center space-y-4">
                <div class="whitespace-pre-wrap w-full text-center">We've resent a verification link to <span class="text-indigo-600">{{ emailVerificationAddress }}</span>.</div>
                <div class="whitespace-pre-wrap w-full text-center">Please check your inbox and follow the instructions to proceed.</div>
                <div class="whitespace-pre-wrap w-full text-center">If you don't receive an email, this address may already be verified. Please <tracked-link :link="{ path: `/auth`, label: 'Sign in', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-semibold hover:text-indigo-800 cursor-pointer">sign in</span></tracked-link> or click <tracked-link :link="{ path: `/password-reset`, label: 'Reset password', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-semibold hover:text-indigo-800">here</span></tracked-link> to reset your password.</div>
            </div>
            <div v-else-if="registrationResponseType=='error'" class="flex flex-col justify-center items-center space-y-4">
                <div class="whitespace-pre-wrap w-full text-center">There was an error sending a verification link to {{ emailVerificationAddress }}.</div>
                <div class="whitespace-pre-wrap w-full text-center">{{ registrationResponse }}</div>
                <div class="whitespace-pre-wrap w-full text-center">If you have already verified this email address, please <tracked-link :link="{ path: `/auth`, label: 'Sign in', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-semibold hover:text-indigo-800 cursor-pointer">sign in</span></tracked-link> or click <tracked-link :link="{ path: `/password-reset`, label: 'Reset password', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-semibold hover:text-indigo-800">here</span></tracked-link> to reset your password.</div>
            </div>
        </div>
        <form v-else @submit.prevent="resendEmail" action="" class="h-full w-full flex flex-col justify-center items-center space-y-4 pt-6">
            <div class="py-3 w-full flex flex-col space-y-4">
                <div class="w-full">
                    <input class="p-3 w-full border border-gray-400 rounded-md" required type="email" placeholder="name@example.com" v-model="emailVerificationAddress">
                </div>
            </div>
            <div class="w-full pt-6 border-t border-gray-300">
                <button 
                    type="submit"
                    :disabled="!validForm"
                    class="px-4 py-3 bg-dark-primary text-white font-semibold  leading-tight rounded-md transition duration-150 ease-in-out w-full"
                    :class="{ 'hover:bg-[#181B4E] hover:shadow-md focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg' : validForm, 'opacity-50' : !validForm}"
                >
                    Continue
                </button>
            </div>   
        </form>
    </div>
</template>

<script setup>
import { defineProps, ref, reactive, computed, onMounted } from 'vue';
import { resendEmailVerification } from '@/services/Auth';
import TrackedLink from '../nav-bar-link-components/TrackedLink.vue';
import LoadingSpinner from '../base-components/LoadingSpinner.vue';
import { handleRestAuthResponseError } from '@/composables/djRestAuth';

import { useRouter } from 'vue-router';

const router = useRouter()

const props = defineProps(['email'])
const isLoading = ref(false)
const registrationResponse = ref(null)
const registrationResponseType = ref(null)

const emailVerificationAddress = ref(props.email && props.email != 'null' ? props.email : null)


const validForm = computed(() => {
    let isValid = false
    if(emailVerificationAddress.value) {
        isValid = true
    }
    return isValid
})

async function resendEmail() {
    console.log('resendEmail')
    isLoading.value = true
    const payload = JSON.stringify({
        email: emailVerificationAddress.value
    })
    console.log(payload)
    const response = await resendEmailVerification(payload)
    console.log('response')
    console.log(response)

    setTimeout(() => {
        isLoading.value = false
        if(response && response.status == 200) {
            registrationResponseType.value = 'success'
        } else {
            registrationResponseType.value = 'error'
            registrationResponse.value = handleRestAuthResponseError(response)
        }
    }, 2000)
}
</script>